import { AppState } from '../Store/App/state';
import { RootState } from '../Store';
import { useSelector } from 'react-redux';

const useIsLoading = (): boolean => {
    const { loading } = useSelector<RootState, AppState>(state => state.app);

    return loading;
};

export default useIsLoading;
